import * as Types from '../../../generated/graphql';

import { CircleTopicFragment } from './topic.generated';
import { gql } from 'graphql.macro';
import { CircleTopicFragmentDoc } from './topic.generated';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CircleFacilitatorFragment = (
  { __typename: 'CircleFacilitatorNode' }
  & Pick<Types.CircleFacilitatorNode, 'id' | 'photo' | 'name' | 'credential' | 'country' | 'countryCode'>
);

export type GetFeaturedQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFeaturedQuery = (
  { __typename: 'Query' }
  & { circleFeaturedCollection: (
    { __typename: 'CircleFeaturedCollection' }
    & Pick<Types.CircleFeaturedCollection, 'totalCount'>
    & { items: Array<(
      { __typename: 'CircleTopicNode' }
      & { facilitators: (
        { __typename: 'CircleFacilitatorConnection' }
        & Pick<Types.CircleFacilitatorConnection, 'totalCount'>
        & { edges: Array<Types.Maybe<(
          { __typename: 'CircleFacilitatorEdge' }
          & Pick<Types.CircleFacilitatorEdge, 'cursor'>
          & { node: (
            { __typename: 'CircleFacilitatorNode' }
            & CircleFacilitatorFragment
          ) }
        )>> }
      ) }
      & CircleTopicFragment
    )> }
  ) }
);

export const CircleFacilitatorFragmentDoc = gql`
    fragment CircleFacilitator on CircleFacilitatorNode {
  id
  photo
  name
  credential
  country
  countryCode
}
    `;
export const GetFeaturedDocument = gql`
    query getFeatured {
  circleFeaturedCollection {
    totalCount
    items {
      __typename
      ... on CircleTopicNode {
        facilitators {
          totalCount
          edges {
            cursor
            node {
              ...CircleFacilitator
            }
          }
        }
        ...CircleTopic
      }
    }
  }
}
    ${CircleFacilitatorFragmentDoc}
${CircleTopicFragmentDoc}`;

/**
 * __useGetFeaturedQuery__
 *
 * To run a query within a React component, call `useGetFeaturedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturedQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedQuery, GetFeaturedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedQuery, GetFeaturedQueryVariables>(GetFeaturedDocument, options);
      }
export function useGetFeaturedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedQuery, GetFeaturedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedQuery, GetFeaturedQueryVariables>(GetFeaturedDocument, options);
        }
export type GetFeaturedQueryHookResult = ReturnType<typeof useGetFeaturedQuery>;
export type GetFeaturedLazyQueryHookResult = ReturnType<typeof useGetFeaturedLazyQuery>;
export type GetFeaturedQueryResult = Apollo.QueryResult<GetFeaturedQuery, GetFeaturedQueryVariables>;